import styled from "@emotion/styled"

export const Styles = styled.div`
  .carousel-container {
    min-width: 355px;
    max-width: ${props => (props.isEvent ? "366px" : "")};
    width: 100%;
    height: ${props => (props.isEvent ? "auto" : "76px")};
    margin-bottom: 45px;
    display: flex;
    align-items: center;

    @media (max-width: 768px) {
      max-width: 100%;
    }
  }

  .carousel {
    width: 100%;
    padding-left: ${props => (props.isEvent ? "0px" : "5px")};
  }

  .carousel .btns button {
    min-width: 314px;
    height: 64px;
    background-color: #fa4616;
    border: none;
    border-radius: 8px;
    font-size: 32px;
    font-weight: 700;
    font-family: "Barlow Condensed";
    line-height: 40px;
  }

  .carousel .btns button:hover {
    background-color: #fa4616;
  }

  .carousel .btn-icon {
    margin-bottom: 5px;
  }

  .slick-slide > div {
    margin: ${props => (props.isEvent ? "0px 0px" : "0 -11px")};
    margin-right: ${props => (props.isEvent ? "0px" : "45px")};
  }

  .slick-dots li {
    margin: 0 0;
  }

  .slick-dots li button:before {
    color: rgb(255, 255, 255) !important;
    font-size: 14px !important;
    margin-top: 20px;
    opacity: 1 !important;
  }

  .slick-dots li.slick-active button:before {
    color: #fa4616 !important;
  }
`
